// Coalesce focus and visibility events emitted together when returning to a tab.
export function watchPageReturn(refresh, page = document, browser = window) {
  let timer
  const schedule = () => {
    clearTimeout(timer)
    if (page.visibilityState === 'visible') {
      timer = setTimeout(() => {
        if (page.visibilityState === 'visible') refresh()
      }, 150)
    }
  }
  page.addEventListener('visibilitychange', schedule)
  browser.addEventListener('focus', schedule)
  browser.addEventListener('online', schedule)
  return () => {
    clearTimeout(timer)
    page.removeEventListener('visibilitychange', schedule)
    browser.removeEventListener('focus', schedule)
    browser.removeEventListener('online', schedule)
  }
}
